(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-box-component')) {
    class BuyBoxComponent extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
        const brace = String.fromCharCode(123, 123);
        const closeBrace = String.fromCharCode(125, 125);
        this.amountToken = brace + 'amount' + closeBrace;
        this.moneyFormat = this.dataset.moneyFormat || ('$' + this.amountToken);
        this.singlePriceEl = this.querySelector('[data-single-price]');
        this.errorEl = this.querySelector('[data-error]');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.countdownEl = this.querySelector('[data-countdown-text]');

        this.selected = this.variants[0] ? this.variants[0].options.slice() : [];
        this.querySelectorAll('[data-option-row]').forEach((row) => {
          const activeButton = row.querySelector('.is-selected');
          if (activeButton) {
            const idx = Number(activeButton.dataset.optionIndex);
            this.selected[idx] = activeButton.dataset.value;
          }
        });

        this.bindTopOptions();
        this.bindBundleSlots();
        this.bindModeSwitch();
        this.bindSubmit();
        this.refreshSingleVariant();
        this.startCountdown();
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      formatMoney(cents) {
        return this.moneyFormat.replace(this.amountToken, (cents / 100).toFixed(2).replace('.', ','));
      }

      findVariant(optionValues) {
        return this.variants.find((variant) =>
          variant.options.every((value, index) => value === optionValues[index])
        );
      }

      bindTopOptions() {
        this.querySelectorAll('[data-option-row] [data-value]').forEach((el) => {
          el.addEventListener('click', () => {
            const idx = Number(el.dataset.optionIndex);
            this.selected[idx] = el.dataset.value;
            const group = el.closest('[data-option-row]');
            group.querySelectorAll('[data-value]').forEach((sibling) => {
              sibling.classList.toggle('is-selected', sibling === el);
            });
            const label = group.querySelector('[data-option-selected-value]');
            if (label) label.textContent = el.dataset.value;
            this.refreshSingleVariant();
          });
        });

        this.querySelectorAll('[data-option-row] select.buy-box__select').forEach((select) => {
          select.addEventListener('change', () => {
            const idx = Number(select.dataset.optionIndex);
            this.selected[idx] = select.value;
            this.refreshSingleVariant();
          });
        });
      }

      refreshSingleVariant() {
        const variant = this.findVariant(this.selected);
        if (!variant) return;
        this.currentSingleVariant = variant;
        if (this.singlePriceEl) this.singlePriceEl.textContent = this.formatMoney(variant.price);
      }

      bindBundleSlots() {
        this.slotSelections = {};
        this.querySelectorAll('[data-slot-select]').forEach((select) => {
          const slot = select.dataset.slot;
          this.slotSelections[slot] = this.slotSelections[slot] || [];
          this.slotSelections[slot][Number(select.dataset.optionIndex)] = select.value;

          select.addEventListener('change', () => {
            this.slotSelections[slot][Number(select.dataset.optionIndex)] = select.value;
            const variant = this.findVariant(this.slotSelections[slot]);
            const img = this.querySelector(`[data-slot="${slot}"] [data-slot-image]`);
            if (variant && img && variant.image) img.src = variant.image;
          });
        });
      }

      bindModeSwitch() {
        this.querySelectorAll(`input[name^="buy-mode-"]`).forEach((radio) => {
          radio.addEventListener('change', () => {
            this.errorEl.hidden = true;
          });
        });
      }

      bindSubmit() {
        this.submitButton.addEventListener('click', () => this.addToCart());
      }

      addToCart() {
        const mode = this.querySelector('input[name^="buy-mode-"]:checked').value;
        let items = [];

        if (mode === 'single') {
          if (!this.currentSingleVariant || !this.currentSingleVariant.available) {
            this.showError();
            return;
          }
          items = [{ id: this.currentSingleVariant.id, quantity: 1 }];
        } else {
          const variants = Object.values(this.slotSelections).map((opts) => this.findVariant(opts));
          if (variants.some((variant) => !variant || !variant.available)) {
            this.showError();
            return;
          }
          items = variants.map((variant) => ({ id: variant.id, quantity: 1 }));
        }

        this.submitButton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('cart-add-failed');
            return response.json();
          })
          .then(() => {
            window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
          })
          .catch(() => {
            this.submitButton.disabled = false;
            this.showError();
          });
      }

      showError() {
        this.errorEl.hidden = false;
      }

      startCountdown() {
        const seconds = Number(this.dataset.countdownSeconds) || 0;
        if (seconds <= 0 || !this.countdownEl) return;

        const storageKey = `buy-box-countdown-${this.dataset.blockId}`;
        let endTime = Number(sessionStorage.getItem(storageKey));
        if (!endTime || endTime < Date.now()) {
          endTime = Date.now() + seconds * 1000;
          sessionStorage.setItem(storageKey, String(endTime));
        }

        const stockLeft = this.dataset.stockLeft;
        const pad = (value) => String(value).padStart(2, '0');

        const tick = () => {
          const remaining = Math.max(0, endTime - Date.now());
          const h = Math.floor(remaining / 3600000);
          const m = Math.floor((remaining % 3600000) / 60000);
          const s = Math.floor((remaining % 60000) / 1000);
          this.countdownEl.textContent = `Aanbieding eindigt over ${pad(h)}:${pad(m)}:${pad(s)} · Nog maar ${stockLeft} stuks beschikbaar!`;
          if (remaining <= 0) clearInterval(this.timer);
        };

        tick();
        this.timer = setInterval(tick, 1000);
      }
    }

    customElements.define('buy-box-component', BuyBoxComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["photo-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('photo-swatches-sync')) {
    class PhotoSwatchesSync extends HTMLElement {
      connectedCallback() {
        // Hide color dropdowns — run after short delay to let variant picker render
        setTimeout(() => { this.hideColorDropdowns(); }, 200);

        var roots = document.querySelectorAll('[data-photo-swatches]');
        roots.forEach((root) => {
          if (root.dataset.swatchBound) return;
          root.dataset.swatchBound = 'true';
          var optionName = root.dataset.optionName;

          root.querySelectorAll('.photo-swatches__item').forEach((btn) => {
            btn.addEventListener('click', () => {
              var color = btn.dataset.color;
              var variantId = btn.dataset.variantId;

              // Update visual selection
              root.querySelectorAll('.photo-swatches__item').forEach((b) => {
                b.classList.toggle('is-selected', b === btn);
                b.setAttribute('aria-pressed', String(b === btn));
              });

              this.selectVariantOption(optionName, color, variantId);
            });
          });
        });
      }

      hideColorDropdowns() {
        var roots = document.querySelectorAll('[data-photo-swatches]');
        roots.forEach((root) => {
          var optionName = root.dataset.optionName;
          if (!optionName) return;
          var optLower = optionName.toLowerCase();

          var pickerEl = document.querySelector('variant-picker');
          if (!pickerEl) return;

          // --- Hide select-based color dropdown ---
          pickerEl.querySelectorAll('select').forEach((sel) => {
            var idL = (sel.id || '').toLowerCase();
            var nameL = (sel.name || '').toLowerCase();
            if (idL.indexOf(optLower) !== -1 || nameL.indexOf(optLower) !== -1) {
              sel.dataset.photoSwatchSelect = 'true';
              var wrapper = sel.closest('fieldset, .variant-option') || sel.parentElement;
              if (wrapper) wrapper.style.display = 'none';
            }
          });

          // --- Hide button/radio-based color option group ---
          // Walk all fieldsets inside variant-picker and hide the one for Kleur
          pickerEl.querySelectorAll('fieldset').forEach((fs) => {
            var legend = fs.querySelector('legend, .variant-option__label, label');
            if (!legend) return;
            var legendText = legend.textContent.replace(/:.*/,'').trim().toLowerCase();
            if (legendText === optLower) {
              fs.style.display = 'none';
            }
          });

          // Also check .variant-option divs (some themes use div instead of fieldset)
          pickerEl.querySelectorAll('.variant-option').forEach((el) => {
            var label = el.querySelector('.variant-option__label, legend, label');
            if (!label) return;
            var labelText = label.textContent.replace(/:.*/,'').trim().toLowerCase();
            if (labelText === optLower) {
              el.style.display = 'none';
            }
          });
        });
      }

      selectVariantOption(optionName, color, variantId) {
        var optLower = optionName.toLowerCase();

        // The variant-picker element contains the selects and handles section re-rendering
        var pickerEl = document.querySelector('variant-picker');

        if (pickerEl) {
          // Find the color select (marked or by name/id match) — works even if display:none
          var colorSelect = pickerEl.querySelector('select[data-photo-swatch-select="true"]') ||
            Array.from(pickerEl.querySelectorAll('select')).find((s) => {
              return (s.id || '').toLowerCase().indexOf(optLower) !== -1 ||
                     (s.name || '').toLowerCase().indexOf(optLower) !== -1;
            }) ||
            Array.from(pickerEl.querySelectorAll('fieldset[style*="display"] select, .variant-option[style*="display"] select')).find((s) => s);

          if (colorSelect) {
            // Find the matching option element
            var matchingOpt = Array.from(colorSelect.options).find(
              (o) => o.value === color || o.text.trim() === color
            );
            if (matchingOpt) {
              colorSelect.value = matchingOpt.value;
              // Dispatch on the SELECT — it bubbles to variant-picker which triggers fetchUpdatedSection
              colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }

          // Fallback: try radio inputs inside variant-picker
          var radios = pickerEl.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radios.length; i++) {
            var r = radios[i];
            var rOptName = (r.dataset.optionName || r.name || '').toLowerCase();
            if (rOptName.indexOf(optLower) !== -1 && r.value === color) {
              r.checked = true;
              r.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
        }

        // Last resort: update URL with variant ID (triggers Horizon re-render on navigation)
        if (variantId) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }
    customElements.define('photo-swatches-sync', PhotoSwatchesSync);
  }
  } catch(e) { console.error(e); }
})();

})();
